import { atom } from 'jotai'

import { type ShipmentOrdersListExEntity } from '@/libs/api'

/**
 * 未配送の複数の配送依頼データ
 *  - 複数の配送依頼をまとめて配車する際に利用
 */
export const multipleShipmentOrdersAtom = atom<ShipmentOrdersListExEntity[]>([])

multipleShipmentOrdersAtom.debugLabel =
  'notDispatchedMultipleShipmentOrdersAtom'
